import React from 'react'

export default function Multiline(props: any) {
  const data: string = props.data
  let multi: any[] = []
  data.split('\n').forEach((text) => {
    if (multi.length > 0) multi.push(<br key={'br ' + text} />)
    const urls: string[] | null = text.match(
      /https?:\/\/[\w!\?/\+\-_~=;\.,\*&@#\$%\(\)'\[\]]+/,
    )
    if (urls) {
      text
        .split(/https?:\/\/[\w!\?/\+\-_~=;\.,\*&@#\$%\(\)'\[\]]+/)
        .forEach((txt) => {
          if (urls.length > 0) {
            multi.push(
              <span key={txt}>
                {txt}
                <a href={urls[0]}>{urls[0]}</a>
              </span>,
            )
            urls.splice(0, 1)
          } else {
            multi.push(<span key={txt}>{txt}</span>)
          }
        })
    } else {
      multi.push(<span key={text}>{text}</span>)
    }
  })
  return <span>{multi}</span>
}
